export interface LocalTenantConfig {
  id: string;
  subdomain: string;
  name: string;
  displayName: string;
  description: string;
  themeConfig?: any;
  branding: {
    primaryColor: string;
    secondaryColor: string;
    backgroundColor: string;
    textColor: string;
    logoUrl?: string;
    faviconUrl?: string;
  };
  contact: {
    phone: string;
    email: string;
    address: string;
    emergencyPhone?: string;
    website?: string;
  };
  features: {
    chatEnabled: boolean;
    servicesEnabled: boolean;
    searchEnabled: boolean;
    workOrderEnabled: boolean;
    salesEnabled: boolean;
    videosEnabled: boolean;
    feedbackEnabled: boolean;
    contactEnabled: boolean;
  };
  businessHours: {
    monday: { open: string; close: string; closed?: boolean };
    tuesday: { open: string; close: string; closed?: boolean };
    wednesday: { open: string; close: string; closed?: boolean };
    thursday: { open: string; close: string; closed?: boolean };
    friday: { open: string; close: string; closed?: boolean };
    saturday: { open: string; close: string; closed?: boolean };
    sunday: { open: string; close: string; closed?: boolean };
  };
  multiLocationMode: boolean;
  timezone: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export const LOCAL_TENANTS: Record<string, LocalTenantConfig> = {
  gmct: {
    id: 'gmct',
    subdomain: 'gmct',
    name: 'GMCT',
    displayName: 'Greater Metropolitan Cemeteries Trust',
    description: 'Serving Melbourne\'s northern and western communities with compassionate cemetery services.',
    themeConfig: {},
    branding: {
      primaryColor: '#D4551B',
      secondaryColor: '#F5F1E8',
      backgroundColor: '#FAFAFA',
      textColor: '#1F2937',
      logoUrl: 'https://nabsxmxjycrerotleoqr.supabase.co/storage/v1/object/public/assets/logos/gmct-logo.png',
      faviconUrl: '/favicons/gmct.png',
    },
    contact: {
      phone: '(03) 8359 0111',
      email: 'info@gmct.com.au',
      address: '123 Memorial Drive, Altona VIC 3018',
      emergencyPhone: '(03) 8359 0100',
      website: 'https://gmct.com.au',
    },
    features: {
      chatEnabled: true,
      servicesEnabled: true,
      searchEnabled: true,
      workOrderEnabled: true,
      salesEnabled: true,
      videosEnabled: true,
      feedbackEnabled: true,
      contactEnabled: true,
    },
    businessHours: {
      monday: { open: '09:00', close: '17:00' },
      tuesday: { open: '09:00', close: '17:00' },
      wednesday: { open: '09:00', close: '17:00' },
      thursday: { open: '09:00', close: '17:00' },
      friday: { open: '09:00', close: '17:00' },
      saturday: { open: '09:00', close: '16:00' },
      sunday: { open: '09:00', close: '16:00' },
    },
    multiLocationMode: true,
    timezone: 'Australia/Melbourne',
    isActive: true,
    createdAt: '2025-01-01T00:00:00Z',
    updatedAt: '2025-01-01T00:00:00Z',
  },
  smct: {
    id: 'smct',
    subdomain: 'smct',
    name: 'SMCT',
    displayName: 'Southern Metropolitan Cemeteries Trust',
    description: 'Providing dignified cemetery services to Melbourne\'s southern communities.',
    themeConfig: {},
    branding: {
      primaryColor: '#1E5A8A',
      secondaryColor: '#F7F7F7',
      backgroundColor: '#FAFAFA',
      textColor: '#1F2937',
      logoUrl: 'https://nabsxmxjycrerotleoqr.supabase.co/storage/v1/object/public/assets/logos/smct-logo.png',
      faviconUrl: '/favicons/smct.png',
    },
    contact: {
      phone: '(03) 8359 0222',
      email: 'info@smct.com.au',
      address: '456 Cemetery Road, Fawkner VIC 3060',
      emergencyPhone: '(03) 8359 0200',
      website: 'https://smct.com.au',
    },
    features: {
      chatEnabled: true,
      servicesEnabled: true,
      searchEnabled: true,
      workOrderEnabled: true,
      salesEnabled: true,
      videosEnabled: true,
      feedbackEnabled: true,
      contactEnabled: true,
    },
    businessHours: {
      monday: { open: '09:00', close: '17:00' },
      tuesday: { open: '09:00', close: '17:00' },
      wednesday: { open: '09:00', close: '17:00' },
      thursday: { open: '09:00', close: '17:00' },
      friday: { open: '09:00', close: '17:00' },
      saturday: { open: '09:00', close: '16:00' },
      sunday: { open: '09:00', close: '16:00' },
    },
    multiLocationMode: false,
    timezone: 'Australia/Melbourne',
    isActive: true,
    createdAt: '2025-01-01T00:00:00Z',
    updatedAt: '2025-01-01T00:00:00Z',
  },
  boroondara: {
    id: 'boroondara',
    subdomain: 'boroondara',
    name: 'Boroondara Cemetery Trust',
    displayName: 'Boroondara Cemetery Trust',
    description: 'Heritage cemetery services for the Boroondara community.',
    themeConfig: {},
    branding: {
      primaryColor: '#059669',
      secondaryColor: '#F0FDF4',
      backgroundColor: '#FAFAFA',
      textColor: '#1F2937',
      logoUrl: 'https://nabsxmxjycrerotleoqr.supabase.co/storage/v1/object/public/assets/logos/boroondara-logo.png',
      faviconUrl: '/favicons/boroondara.png',
    },
    contact: {
      phone: '(03) 8359 0333',
      email: 'info@boroondara.com.au',
      address: '789 Heritage Lane, Boroondara VIC 3124',
      emergencyPhone: '(03) 8359 0300',
      website: 'https://boroondara.com.au',
    },
    features: {
      chatEnabled: true,
      servicesEnabled: true,
      searchEnabled: true,
      workOrderEnabled: true,
      salesEnabled: true,
      videosEnabled: true,
      feedbackEnabled: true,
      contactEnabled: true,
    },
    businessHours: {
      monday: { open: '09:00', close: '17:00' },
      tuesday: { open: '09:00', close: '17:00' },
      wednesday: { open: '09:00', close: '17:00' },
      thursday: { open: '09:00', close: '17:00' },
      friday: { open: '09:00', close: '17:00' },
      saturday: { open: '09:00', close: '16:00' },
      sunday: { open: '09:00', close: '16:00' },
    },
    multiLocationMode: false,
    timezone: 'Australia/Melbourne',
    isActive: true,
    createdAt: '2025-01-01T00:00:00Z',
    updatedAt: '2025-01-01T00:00:00Z',
  },
};

// Local locations for tenants
export const LOCAL_LOCATIONS: Record<string, any[]> = {
  gmct: [
    {
      id: 'altona-memorial-park',
      name: 'Altona Memorial Park',
      address: '123 Memorial Drive, Altona VIC 3018',
      phone: '(03) 8359 0111',
      coordinates: {
        latitude: -37.8136,
        longitude: 144.9631
      },
      businessHours: {
        monday: { open: '09:00', close: '17:00' },
        tuesday: { open: '09:00', close: '17:00' },
        wednesday: { open: '09:00', close: '17:00' },
        thursday: { open: '09:00', close: '17:00' },
        friday: { open: '09:00', close: '17:00' },
        saturday: { open: '09:00', close: '16:00' },
        sunday: { open: '09:00', close: '16:00' },
      },
      isMainLocation: true,
      createdAt: '2025-01-01T00:00:00Z',
      updatedAt: '2025-01-01T00:00:00Z',
    },
    {
      id: 'fawkner-memorial-park',
      name: 'Fawkner Memorial Park',
      address: '456 Cemetery Road, Fawkner VIC 3060',
      phone: '(03) 8359 0112',
      coordinates: {
        latitude: -37.7136,
        longitude: 144.9531
      },
      businessHours: {
        monday: { open: '09:00', close: '17:00' },
        tuesday: { open: '09:00', close: '17:00' },
        wednesday: { open: '09:00', close: '17:00' },
        thursday: { open: '09:00', close: '17:00' },
        friday: { open: '09:00', close: '17:00' },
        saturday: { open: '09:00', close: '16:00' },
        sunday: { open: '09:00', close: '16:00' },
      },
      isMainLocation: false,
      createdAt: '2025-01-01T00:00:00Z',
      updatedAt: '2025-01-01T00:00:00Z',
    },
    {
      id: 'emerald-cemetery',
      name: 'Emerald Cemetery',
      address: '789 Emerald Hill, Emerald VIC 3782',
      phone: '(03) 8359 0113',
      coordinates: {
        latitude: -37.9136,
        longitude: 145.4531
      },
      businessHours: {
        monday: { open: '09:00', close: '16:00' },
        tuesday: { open: '09:00', close: '16:00' },
        wednesday: { open: '09:00', close: '16:00' },
        thursday: { open: '09:00', close: '16:00' },
        friday: { open: '09:00', close: '16:00' },
        saturday: { open: '10:00', close: '15:00' },
        sunday: { open: '10:00', close: '15:00' },
      },
      isMainLocation: false,
      createdAt: '2025-01-01T00:00:00Z',
      updatedAt: '2025-01-01T00:00:00Z',
    }
  ],
  smct: [
    {
      id: 'southern-memorial-park',
      name: 'Southern Memorial Park',
      address: '456 Cemetery Road, Fawkner VIC 3060',
      phone: '(03) 8359 0222',
      coordinates: {
        latitude: -37.8536,
        longitude: 145.0631
      },
      businessHours: {
        monday: { open: '09:00', close: '17:00' },
        tuesday: { open: '09:00', close: '17:00' },
        wednesday: { open: '09:00', close: '17:00' },
        thursday: { open: '09:00', close: '17:00' },
        friday: { open: '09:00', close: '17:00' },
        saturday: { open: '09:00', close: '16:00' },
        sunday: { open: '09:00', close: '16:00' },
      },
      isMainLocation: true,
      createdAt: '2025-01-01T00:00:00Z',
      updatedAt: '2025-01-01T00:00:00Z',
    }
  ],
  boroondara: [
    {
      id: 'boroondara-cemetery',
      name: 'Boroondara Cemetery',
      address: '789 Heritage Lane, Boroondara VIC 3124',
      phone: '(03) 8359 0333',
      coordinates: {
        latitude: -37.8236,
        longitude: 145.0831
      },
      businessHours: {
        monday: { open: '09:00', close: '17:00' },
        tuesday: { open: '09:00', close: '17:00' },
        wednesday: { open: '09:00', close: '17:00' },
        thursday: { open: '09:00', close: '17:00' },
        friday: { open: '09:00', close: '17:00' },
        saturday: { open: '09:00', close: '16:00' },
        sunday: { open: '09:00', close: '16:00' },
      },
      isMainLocation: true,
      createdAt: '2025-01-01T00:00:00Z',
      updatedAt: '2025-01-01T00:00:00Z',
    }
  ]
};
/**
 * Get local tenant configuration by subdomain
 */
export function getLocalTenant(subdomain: string): LocalTenantConfig | null {
  return LOCAL_TENANTS[subdomain] || null;
}

/**
 * Get local locations for a tenant
 */
export function getLocalLocations(subdomain: string): any[] {
  return LOCAL_LOCATIONS[subdomain] || [];
}

/**
 * Check if subdomain has local configuration
 */
export function hasLocalTenant(subdomain: string): boolean {
  return subdomain in LOCAL_TENANTS;
}